<template>
  <app-layout>
    <app-header>
      <div class="flex flex-wrap items-end">
        <div class="flex-1">
          <icon-link
            :href="backLink"
            icon="arrow-thin-left-circle"
            class="icons-secondary"
          >
            Back to assessments
          </icon-link>
          <h1>
            <app-badge
              v-if="badgeInfo"
              :icon="badgeInfo.icon"
              :type="badgeInfo.type"
            >
              <template v-if="state.project.awarded_at !== null">
                Awarded
              </template>
              <template v-else-if="state.project.rejected_at !== null">
                Rejected
              </template>
              <template v-else-if="state.project.invited_at !== null">
                Invited
              </template>
            </app-badge>
            <span class="block">{{ state.project.ref }} Application Form</span>
            <small class="font-normal text-xs opacity-50 leading-none block">
              {{ state.competition.title }} Competition
            </small>
          </h1>
        </div>
        <div class="w-48 text-right">
          <portal-target name="scoring" slim />
        </div>
      </div>
      <template #navigation>
        <ul v-if="tabs">
          <li v-for="(item, index) in tabs" :key="index">
            <a
              :href="
                `${route('assessments.view', state.project.uuid)}#${item.hash}`
              "
            >
              {{ item.name }}
              <span
                v-if="groupedErrors[item.name] && showErrors"
                class="inline-block text-3xs bg-negative-500 text-white p-1 align-text-top"
              >
                {{ groupedErrors[item.name].length }}
              </span>
            </a>
          </li>
          <li>
            <a
              :href="route('assessments.grade', state.project.uuid)"
              class="tab-grading is-active"
            >
              Grade Assessment
            </a>
          </li>
        </ul>
      </template>
    </app-header>
    <div class="container">
      <div
        v-if="isLocked && noGradingStatuses"
        class="text-xs border-l-4 -mt-8 mb-6 px-3 py-2 overflow-hidden"
        :class="{
          'bg-positive-100 border-positive-600 text-positive-800':
            state.project.invited_at,
          'bg-neutral-100 border-neutral-600 text-neutral-800': !state.project
            .invited_at
        }"
      >
        <icon
          icon="lock"
          class="w-3 h-3 mr-1"
          :class="{
            'icons-positive': state.project.invited_at,
            'icons-neutral': !state.project.invited_at
          }"
        />
        <template v-if="state.project.invited_at">
          <strong class="uppercase">Grading Locked:</strong> The grading for
          this competition is currently locked and will be reopened during the
          interview period.
        </template>
        <template v-else>
          <strong class="uppercase">Grading Locked:</strong> The grading for
          this competition is currently locked. This is likely due to onging
          review by the funding team.
        </template>
      </div>
      <application-grade
        :grading-status="state.competition.grading_status"
        :competition="state.competition"
        :project="state.project.uuid"
        :assessment="fieldsets"
        :grades="state.grading"
        :is-locked="isLocked"
        :project-status-dates="projectStatusDates"
        :user="state.user"
      />
      <ul class="list-reset flex justify-between items-baseline">
        <li class="w-1/3">
          <icon-link
            v-if="active > 0"
            :href="'#' + tabs[active - 1].hash"
            icon="arrow-thin-left-circle"
            @click.stop.prevent="setActive(active - 1)"
          >
            Previous: {{ tabs[active - 1].name }}
          </icon-link>
          <icon-link :href="backLink" icon="arrow-thin-left-circle">
            Back to application
          </icon-link>
        </li>
        <li class="w-1/3 text-center">
          <icon-link
            :href="route('assessments.index')"
            class="text-positive-600 hover:text-positive-800"
          >
            All Assessments
          </icon-link>
        </li>
        <li class="w-1/3 text-right"></li>
      </ul>
    </div>
  </app-layout>
</template>

<script>
import kebabCase from "lodash/kebabCase";
import { requestMixin } from "../mixins/request";
import { applicationMixin } from "../mixins/application";
import { store } from "../store/application";
export default {
  name: "AssessmentGrade",
  mixins: [requestMixin, applicationMixin],
  computed: {
    backLink() {
      return `${route("assessments.index")}#${kebabCase(
        this.state.competition.title
      )}`;
    },
    projectStatusDates() {
      return {
        rejected_at: this.state.project.rejected_at,
        withdrawn_at: this.state.project.withdrawn_at,
        shortlisted_at: this.state.project.shortlisted_at,
        awarded_at: this.state.project.awarded_at,
        initial_notified_at: this.state.project.initial_notified_at,
        interview_notified_at: this.state.project.interview_notified_at
      };
    },
    isLocked() {
      return (
        Boolean(this.state.competition.funding_pots[0].grading_locked) ||
        this.state.project.rejected_at !== null ||
        this.state.project.withdrawn_at !== null ||
        this.state.project.shortlisted_at !== null ||
        this.state.project.awarded_at !== null
      );
    },
    noGradingStatuses() {
      return (
        this.state.project.rejected_at === null &&
        this.state.project.awarded_at === null &&
        this.state.project.shortlisted_at === null &&
        this.state.project.withdrawn_at === null
      );
    },
    singleStageGrading() {
      return this.state.competition.single_stage_grading > 0;
    },
    badgeInfo() {
      return this.state.project.awarded_at !== null
        ? {
            type: "positive",
            icon: "check"
          }
        : this.state.project.rejected_at !== null
        ? {
            type: "negative",
            icon: "close-circle"
          }
        : this.state.project.withdrawn_at !== null
        ? {
            type: "passed",
            icon: "close-circle"
          }
        : this.state.project.shortlisted_at !== null
        ? {
            type: "neutral",
            icon: "time"
          }
        : this.state.project.invited_at !== null && !this.singleStageGrading
        ? {
            type: "positive",
            icon: "time"
          }
        : false;
    }
  },
  created() {
    store.reviewMode = true;
  }
};
</script>
